<app-preloader></app-preloader>
<app-navbar></app-navbar>
<router-outlet></router-outlet>
<app-footer></app-footer>
<ngx-scrolltop [size]="40" backgroundColor="#A23E41"></ngx-scrolltop>